// extracted by mini-css-extract-plugin
export default {"nav__item":"NavItem_nav__item__ViBdR","navlink":"NavItem_navlink__B8qIr","navLinkActive":"NavItem_navLinkActive__fxOqC"};